import { electronModule } from "@/modules/electron";
import { logger } from "@/modules/logger";
import { objectModule } from "@/modules/object";

type SyncDesktopOAuthAccessTokenArgs = {
  authToken: string | null;
};

export const syncDesktopOAuthAccessTokenAsync = async ({
  authToken,
}: SyncDesktopOAuthAccessTokenArgs): Promise<void> => {
  try {
    if (authToken) {
      await electronModule.oauthAccessToken.set({ token: authToken });
      return;
    }

    await electronModule.oauthAccessToken.clear();
  } catch (unknownErr) {
    logger.warn({
      message: "[syncDesktopOAuthAccessToken] Failed to sync OAuth access token to desktop.",
      info: {
        error: objectModule.safeErrorAsJson(unknownErr as Error),
        hasAuthToken: Boolean(authToken),
      },
    });
  }
};

export const syncDesktopOAuthAccessToken = (args: SyncDesktopOAuthAccessTokenArgs): void => {
  void syncDesktopOAuthAccessTokenAsync(args);
};
